import { FilterOps, TextMaterialCategory } from '@@types'
import { useTranslation } from 'react-i18next'
import { generatePath, useParams } from 'react-router'

import {
  useFetchAllTextMaterials,
  useFetchTextMaterialCategories,
} from '@entities/Blog'


import { CartPreview } from '@features/cart'

import { BlogList } from '@widgets/blog-list'

import SEO from '@shared/components/SEO'
import { URL_BLOG, URL_BLOG_CATEGORY } from '@shared/contants'
import { BRAND_NAME } from '@shared/contants/app'
import { useLocalizedNavigate as useNavigate } from '@shared/lib/locale'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import PageGrid from '@shared/ui/page-grid'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function BlogPage () {
  const { t: tb } = useTranslation('blog')
  const { t } = useTranslation('seo')

  const { categorySlug, themeSlug, tagSlug } = useParams()
  const navigate = useNavigate()

  const { textMaterials } = useFetchAllTextMaterials({
    filter: {
      and: [
        {
          or: [
            {
              fields: [ 'themeSlug' ],
              op: themeSlug ? FilterOps.EQUAL : FilterOps.UNWRAP,
              value: themeSlug
            },
            {
              fields: [ 'tagSlug' ],
              op: tagSlug ? FilterOps.CONTAINS : FilterOps.UNWRAP,
              value: tagSlug
            },
            {
              fields: [ 'categorySlug' ],
              op: categorySlug ? FilterOps.EQUAL : FilterOps.UNWRAP,
              value: categorySlug
            }
          ]
        },
        {
          fields: [ 'typeSlug' ],
          op: FilterOps.NOT_EQUAL,
          value: [ 'static' ] // Exclude 'static' type
        }
      ]
    }
  })

  const { textMaterialCategories } = useFetchTextMaterialCategories()

  const handleCategoryClick = (category?: TextMaterialCategory) => {
    if (!category) {
      navigate(URL_BLOG)
      return
    }
    const categoryUrl = generatePath(URL_BLOG_CATEGORY, {
      categorySlug: category.slug,
    })
    navigate(categoryUrl)
  }

  const selectedCategory = textMaterialCategories.find(
    (category) => category.slug === categorySlug,
  )

  return (
    <Container>
      <SEO
        title={t('blog.title', { brand: BRAND_NAME })}
        description={t('blog.description', { brand: BRAND_NAME })}
      />
      <PageGrid aside={<CartPreview />}>
        <Wrapper className={styles.wrapper}>
          <Breadcrumbs
            className={styles.breadcrumbs}
            links={[
              {
                title: tb('blog'),
              },
              ...(selectedCategory?.title && selectedCategory.slug
                ? [
                  {
                    title: selectedCategory.title,
                    to: generatePath(URL_BLOG_CATEGORY, {
                      categorySlug: selectedCategory.slug,
                    }),
                  },
                ]
                : []),
              ...(themeSlug
                ? [
                  {
                    title: themeSlug,
                    to: generatePath(URL_BLOG_CATEGORY, {
                      categorySlug: themeSlug,
                    }),
                  },
                ]
                : []),
              ...(tagSlug
                ? [
                  {
                    title: tagSlug,
                    to: generatePath(URL_BLOG_CATEGORY, {
                      categorySlug: tagSlug,
                    }),
                  },
                ]
                : []),
            ]}
          />

          <BlogList
            currentCategorySlug={categorySlug}
            showCategories={!themeSlug && !tagSlug}
            articles={textMaterials}
            categories={textMaterialCategories}
            onCategoryChange={handleCategoryClick}
          />
          {/* <BannerApp /> */}
        </Wrapper>
      </PageGrid>
    </Container>
  )
}
